var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import background from "./background";
import borderMixIn from "./border";
import shadow from "./shadow";
var clearEmptyLines = function (str) { return str.replace(/^(?=\n)$|^\s*|\s*$|\n\n+/gm, ""); };
export var callAllFunctionsAndMergeResults = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    var result = "";
    return function mergedFn(arg) {
        fns.forEach(function (fn) {
            var functionResult = fn && typeof fn === "function" ? fn(arg) : "";
            result = result + functionResult;
        });
        return result;
    };
};
export var pseudoSelectors = {
    _before: "&::before",
    _after: "&::after",
    _hover: "&:hover, &[data-hover]",
    _active: "&:active, &[data-active]",
    _focus: "&:focus, &[data-focus]",
    _focusWithin: "&:focus-within",
    _visited: "&:visited",
    _empty: "&:empty",
    _even: "&:nth-of-type(even)",
    _odd: "&:nth-of-type(odd)",
    _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
    _checked: "&[aria-checked=true]",
    _mixed: "&[aria-checked=mixed]",
    _selected: "&[aria-selected=true], [data-selected] > &",
    _invalid: "&[aria-invalid=true]",
    _pressed: "&[aria-pressed=true]",
    _readOnly: "&[aria-readonly=true], &[readonly]",
    _first: "&:first-of-type",
    _last: "&:last-of-type",
    _expanded: "&[aria-expanded=true]",
    _grabbed: "&[aria-grabbed=true]",
    _notFirst: "&:not(:first-of-type)",
    _notLast: "&:not(:last-of-type)",
    _groupHover: "[role=group]:hover &",
    _autofill: "&:-webkit-autofill",
    _placeholder: "&::placeholder",
};
export default (function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    var pseudo = "";
    for (var prop in props) {
        if (prop in pseudoSelectors) {
            var pseudoProp = prop;
            var pseudoStyles = props[pseudoProp];
            var styles = callAllFunctionsAndMergeResults(shadow, borderMixIn, background)(__assign({ theme: theme }, pseudoStyles));
            pseudo =
                pseudo +
                    "\n      ".concat(pseudoSelectors[pseudoProp], "{ \n        ").concat(styles, " \n      }");
        }
    }
    return clearEmptyLines(pseudo);
});
